import { getJurisdiction,insertJurisdiction,updateJurisdiction,deleteJurisdiction } from "../../api/config/modules/JurisdictionalManagement";

const state = {
    getJurisdiction: {},
    insertJurisdiction: {},
    updateJurisdiction: {},
    deleteJurisdiction: {}
};

const mutations = {
    SET_GETJURISDICTION: (state, getJurisdiction) => {
        state.getJurisdiction = getJurisdiction;
    },
    SET_INSERTJURISDICTION: (state, insertJurisdiction) => {
        state.insertJurisdiction = insertJurisdiction;
    },
    SET_UPDATEJURISDICTION: (state, updateJurisdiction) => {
        state.updateJurisdiction = updateJurisdiction;
    },
    SET_DELETEJURISDICTION: (state, deleteJurisdiction) => {
        state.deleteJurisdiction = deleteJurisdiction;
    },
};

const actions = {
    GET_GETJURISDICTION: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getJurisdiction(data)
                .then((res) => {
                    commit("SET_GETJURISDICTION", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTJURISDICTION: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertJurisdiction(data)
                .then((res) => {
                    commit("SET_INSERTJURISDICTION", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEJURISDICTION: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateJurisdiction(data)
                .then((res) => {
                    commit("SET_UPDATEJURISDICTION", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEJURISDICTION: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteJurisdiction(data)
                .then((res) => {
                    commit("SET_DELETEJURISDICTION", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
